'use strict'

import is_ip_private from './lib/index.js'
export default is_ip_private